import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const contracttypology = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/contract-typology',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'contracttypology' }
    ),
    { }
  )
)()

export { contracttypology, TYPES }
